// accounts page headings
export const Accounts = ["Subscription", "Security"];
